import { api } from "api/apiService";

/**
 * Запитує у бекенда генерацію PDF-файлу каталогу.
 * @param {string[]} skus - Масив артикулів (SKU) для каталогу (від 1 до 255 елементів).
 * @param {string} [templateId] - Ідентифікатор шаблону каталогу.
 * @returns {Promise<Blob>} - Promise, який повертає PDF-файл у вигляді Blob.
 */
export const generateCatalogPdf = (skus, templateId) => {
  return api.post(
    "/catalog/generate",
    { skus, templateId },
    { responseType: "blob" },
  );
};

/**
 * Повертає список доступних шаблонів каталогу.
 * @returns {Promise<Array<{id: string, name: string}>>}
 */
export const fetchCatalogTemplates = () => api.get("/catalog/templates");
